<template>
  <div>
    <!-- table principal -->
    <el-row :gutter="20">
      <el-col :span="4">
        <!-- <h1>KPI VENTAS</h1> -->
        <yearcomponent @change="handler_year" class="box-item"></yearcomponent>
      </el-col>
      <el-col :span="4">
        <el-select
          v-model="deal"
          placeholder="Tipo de contrato"
          @change="handleSelection"
          v-bind="$attrs"
          size="mini"
        >
          <el-option
            v-for="item in dealist"
            :key="item"
            :label="item.label"
            :value="item.Value"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <rabbey-table3
          :columns="columns2"
          :show-summary="true"
          :summary-method="getTotalByMonthVendors"
          :default-items="items"
          :paginateFromApi="false"
          v-loading="principalTable"
          :data="items"
        />
      </el-col>
    </el-row>

    <!-- table detalle por Vendedor -->
    <DetailReportSales ref="details" :year="year2" />
  </div>
</template>

<script>
import yearcomponent from "@/components/Global_System/YearsComponent.vue";
import { Months, commentColumns } from "../../../../helpers/SalesReportColumns";
import { getTotalByMonthVendors } from "../../../../helpers/TableRabbeyTools";
import DetailReportSales from "./DetailReportSales.vue";

export default {
  name: "DealsKpi",
  components: { DetailReportSales, yearcomponent },
  props: {
    year: Number
  },
  data() {
    return {
      data: [],
      principalTable: true,
      loadingDetails: true,
      deals: false,
      formpayment: false,
      year2: new Date().getFullYear(),
      deal: "",
      dealist: [
        {
          label: "Todas",
          Value: "T"
        },

        {
          label: "Nuevo Contrato",
          Value: "N"
        },
        {
          label: "Viejo Contrato",
          Value: "V"
        }
      ],
      value: "",
      TypeAgent: "customerservice",
      type: "Cantidad",
      SellerName: "",
      contacts: [],
      loadingContacts: false,
      month: "",
      MontlyTarget: "",
      AccountNumber: "",
      InvoiceNum: "",
      ContactEmail: "",
      form: {
        currentdate: "",
        newdate: "",
        comment: "",
        contactCode: ""
      },

      columns: [
        {
          prop: "SellerName",
          label: "Vendedor",
          minWidth: 220,
          fixed: true
        },
        ...Months
      ],
      columns2: [
        {
          prop: "SellerName",
          label: "Vendedor",
          minWidth: 220,
          fixed: true
        },
        ...this.mapOb(Months)
      ],

      columnsComments: [...commentColumns],
      items: [],
      comments: [],
      Dcoments: false,
      commentloading: false
    };
  },
  created() {
    this.getData();
  },
  computed: {
    isValid: function () {
      return this.form.comment.trim().length > 5 && this.form.newdate !== null;
    }
  },
  methods: {
    getTotalByMonthVendors,
    openDetail(mes, row) {
      this.$refs.details.show(row, mes, this.deal);
    },
    getTest() {
      return this.type;
    },
    mapOb(data) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        element.cellAtrrs = {
          getTest: this.getTest,
          openDetail: this.openDetail,
          ...element.cellAtrrs
        };
      }
      return data;
    },
    handler_year(_year) {
      this.year2 = _year;
      this.getData();
    },
    handleClose() {
      this.form.currentdate = "";
      this.form.newdate = "";
      this.form.comment = "";
      this.form.contactCode = "";
      this.AccountNumber = "";
      this.InvoiceNum = "";
      this.ContactEmail = "";
    },

    handlerChanges() {
      this.getData();
    },

    handleSelection() {
      this.getData();
    },

    getData() {
      let params = {
        year: this.year2,
        CompanyId: this.currentCompany,
        TypeDeal: this.deal
      };
      this.principalTable = true;
      // this.$store.commit("rabbey_table/loading");
      this.$http
        .get("/api/SalesApi/SummaryGrupedByMoths", {
          params: params
        })
        .then(({ data }) => {
          this.items = data;
          // this.$store.commit("rabbey_table/items", data);
        })
        .finally(() => {
          // this.$store.commit("rabbey_table/success");
          this.principalTable = false;
        });
    }
  },
  watch: {
    year() {
      this.year2 = this.year;
      this.getData();
    }
  }
};
</script>

<style>
#table-card td {
  padding-left: 10px;
}
.col-p {
  padding: 0 10px;
  box-sizing: border-box;
}
</style>
